var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass:
        "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide block text-center w-full px-4 py-3 mt-3",
      attrs: { to: { name: "emergency.new", query: _vm.$route.query } }
    },
    [_vm._v(_vm._s(_vm.$t("Enable_the_appointment_alert")))]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14fa5973", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14fa5973","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/WaitingListButton.vue
// module id = 761
// module chunks = 1